import React, { useState, useEffect } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  message,
} from 'antd'
import {
  Div, Button, Input, H5, P, H4,
} from 'konsys-ui'
import PATH from '../../constants/path'
import Container from '../../components/container'
import Home from '../home'
import ReturnPage from '../../components/common/return-page'
import { theme, screenSize } from '../../styles/_variables'
import { CHECK_TOKEN } from '../../constants/graph/query'
import { RESET_PASSWORD } from '../../constants/graph/mutation'
import Banner from '../../images/member/banner.jpg'
import {
  WidthContainer, CenterContainer, Instruction,
} from './styled'

const ChangeSuccess = ({ isShowModal }) => (
  <Div margin='32px 0'>
    <ReturnPage
      title='ตั้งรหัสผ่านใหม่เรียบร้อย'
      buttonData={[
        {
          link: PATH.home,
          title: 'กลับสู่หน้าแรก',
          style: 'inverse',
        }, {
          // link: PATH.member,
          // title: 'ไปยังบัญชีผู้ใช้',
          // style: 'inverse',
          title: 'ไปยังบัญชีผู้ใช้',
          style: 'inverse',
          link: PATH.login,
          type: 'login',
        },
      ]}
      // isShowModal={value => setIsShowModal(value)}
      isShowModal={value => isShowModal(value)}
    >
      <P style={{ fontWeight: 'bold' }} color={theme.color.lightGrey}>ตั้งรหัสผ่านใหม่เรียบร้อยแล้ว คุณสามารถใช้รหัสผ่านใหม่</P><br></br>
      <P style={{ fontWeight: 'bold' }} color={theme.color.lightGrey}>เพื่อเข้าสู่ระบบครั้งต่อไปได้ทันที</P>
    </ReturnPage>
  </Div>
)

const NewPassword = ({ token }) => {
  const [password, setPassword] = useState()
  const [again, setAgain] = useState()
  const [changeSuccess, setChangeSuccess] = useState(false)
  const [windowSize, setWindowSize] = useState(window.innerWidth)
  const [isShowModal, setIsShowModal] = useState(false)

  const checkInput = (c, m) => {
    switch (m) {
      case 0: if (!/\s/.test(c)) {
        setPassword(c)
      } break
      case 1: if (!/\s/.test(c)) {
        setAgain(c)
      } break
      default:
    }
  }

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowSize(window.innerWidth)
    })
  })

  const isTabletS = windowSize <= screenSize.tabletS

  return (
    <Container
      header={{
        type: 'title',
        img: Banner,
        title: 'บัญชีผู้ใช้',
        color: theme.color.tertiaryColor,
      }}
      blur={isShowModal}
    >
      <WidthContainer>
        {
          changeSuccess
            ? <ChangeSuccess
              isShowModal={value => setIsShowModal(value)}
            />
            : <CenterContainer>
            <Div textAlign='left' width='270px'>
              <H4 margin='0 0 16px' color={theme.color.tertiaryColor}>ตั้งรหัสผ่านใหม่</H4>
            </Div>
            <Div margin='24px 0' display='flex' flexDirection='column'>
              <Div display='flex' flexDirection='column' margin='0 0 16px'>
                <H5 margin='0 0 8px' color={theme.color.primaryColor}>รหัสผ่านใหม่</H5>
                <Input width={isTabletS && '100%'} value={password} type='password' onChange={e => checkInput(e.target.value, 0)}/>
                <Instruction>กรุณากรอกรหัสผ่านอย่างน้อย 6 ตัว ด้วยภาษาอังกฤษ ตัวเลข หรือสัญลักษณ์</Instruction>
              </Div>
              <Div display='flex' flexDirection='column'>
                <H5 margin='0 0 8px' color={theme.color.primaryColor}>รหัสผ่านใหม่ (อีกครั้ง)</H5>
                <Input width={isTabletS && '100%'} value={again} type='password' onChange={e => checkInput(e.target.value, 1)}/>
                <Instruction>กรุณากรอกรหัสผ่านใหม่ให้เหมือนกัน</Instruction>
              </Div>
            </Div>
            <Div margin='8px 0 0' display='flex' justifyContent='center'>
              <Mutation
                mutation={RESET_PASSWORD}
              >{doResetPassword => (
                <Button
                  disabled={
                    _.isUndefined(password)
                    || _.isUndefined(again)
                    || password !== again
                    || password.length < 6
                    || again.length < 6
                  }
                  margin='0 8px'
                  inverse
                  buttonStyle="round"
                  color={theme.color.secondaryColor}
                  text='เปลี่ยนรหัสผ่าน'
                  onClick={() => doResetPassword({
                    variables: {
                      token,
                      newPassword: password,
                    },
                  }).then((resp) => {
                    if (resp.data.resetPassword.success) {
                      setChangeSuccess(true)
                    } else {
                      message.error(resp.data.resetPassword.message)
                    }
                  })}
                />
              )
              }
              </Mutation>
            </Div>
          </CenterContainer>
        }
      </WidthContainer>
    </Container>
  )
}

const ResetPassword = props => (
  <Query
    query={CHECK_TOKEN}
    variables={{
      token: props.match.params.token,
    }}
  >
    {
      (res) => {
        if (!res.data.checkToken) {
          return <Home/>
        }
        return <NewPassword token={props.match.params.token}/>
      }
    }
  </Query>
)

export default ResetPassword



// WEBPACK FOOTER //
// ./src/pages/forget-password/new-password.jsx